// extracted by mini-css-extract-plugin
export var contentBody = "_de-9";
export var headerImage = "_de-2";
export var imageButton = "_de-7";
export var imageButtonIcon = "_de-8";
export var imageHeader = "_de-4";
export var imageHeaderText = "_de-5";
export var imageOverlay = "_de-3";
export var imageTitle = "_de-6";
export var imageWrapper = "_de-1";
export var taskList = "_de-a";
export var widget = "_de-0";